export default __webpack_public_path__ + "static/iso-79c1020c821e6ae9218988d5e5daf3a0.png";